"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertStringExpressionToAscii = convertStringExpressionToAscii;
function convertStringExpressionToAscii(input) {
    if (!input) {
        return input;
    }
    let result = input;
    result = result.replace(/×/g, '*');
    result = result.replace(/·/g, '*');
    result = result.replace(/⋅/g, '*');
    result = result.replace(/÷/g, '/');
    result = result.replace(/±/g, '+/-');
    result = result.replace(/−/g, '-');
    result = result.replace(/[–—]/g, '-');
    result = result.replace(/≤/g, '<=');
    result = result.replace(/≥/g, '>=');
    result = result.replace(/≠/g, '!=');
    result = result.replace(/[⁰¹²³⁴⁵⁶⁷⁸⁹⁻]+/g, (match) => {
        const converted = match
            .replace(/⁰/g, '0')
            .replace(/¹/g, '1')
            .replace(/²/g, '2')
            .replace(/³/g, '3')
            .replace(/⁴/g, '4')
            .replace(/⁵/g, '5')
            .replace(/⁶/g, '6')
            .replace(/⁷/g, '7')
            .replace(/⁸/g, '8')
            .replace(/⁹/g, '9')
            .replace(/⁻/g, '-');
        return '^' + converted;
    });
    result = result.replace(/[₀₁₂₃₄₅₆₇₈₉]+/g, (match) => {
        const converted = match
            .replace(/₀/g, '0')
            .replace(/₁/g, '1')
            .replace(/₂/g, '2')
            .replace(/₃/g, '3')
            .replace(/₄/g, '4')
            .replace(/₅/g, '5')
            .replace(/₆/g, '6')
            .replace(/₇/g, '7')
            .replace(/₈/g, '8')
            .replace(/₉/g, '9');
        return '_' + converted;
    });
    return result;
}
//# sourceMappingURL=ascii-conversion.js.map